<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet />
      <ion-tab-bar
        slot="bottom"
        :style="
          useDynamicColors && {
            '--background': primaryColor,
            '--border': '0px',
          }
        "
      >
        <ion-tab-button
          v-for="(tab, index) in tabs"
          :key="`${tab.tab}-${index}`"
          :tab="tab.tab"
          :href="tab.href"
          @click="trackHome(tab.tab)"
        >
          <ion-icon :icon="tab.icon" />
          <ion-label>{{ tab.label }}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script setup>
import {
  IonTabBar,
  IonTabButton,
  IonTabs,
  IonLabel,
  IonIcon,
  IonPage,
  IonRouterOutlet,
} from '@ionic/vue';
import { book, home, search } from 'ionicons/icons';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

import { useRoute } from 'vue-router';
import { computed } from 'vue';
import useTracking from '@/composables/useTracking';
import { TRACKING_HOME } from '@/config/constants';

import useBackgroundColor from '@/composables/useBackgroundColor';

defineOptions({
  name: 'AccreditationExam',
});

const { t } = useI18n();
const route = useRoute();
const store = useStore();

const { trackThis } = useTracking();

const tabRoutes = computed(() => {
  return [
    {
      label: t('mainNav.home'),
      tab: 'home',
      href: '/main/home',
      icon: home,
      selected: false,
    },
    {
      label: t('mainNav.search'),
      tab: 'search',
      href: '/main/search',
      icon: search,
      selected: false,
    },
    {
      label: t('mainNav.library'),
      tab: 'following',
      href: '/main/following',
      icon: book,
      selected: false,
    },
  ];
});

const tabs = computed(() =>
  tabRoutes.value.map((tab) => {
    tab.selected = tab.href === route.path;
    return tab;
  }),
);

const trackHome = (tab) => {
  if (tab === 'search') {
    store.dispatch('search/setShowSearch', true);
    return;
  }

  if (tab === 'home') {
    trackThis(TRACKING_HOME);

    const isAlreadyOnTheHomePage = route.path === '/main/home';
    if (isAlreadyOnTheHomePage) {
      const topElement = document.querySelector('#top');

      if (topElement) {
        topElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }
  }

  store.dispatch('search/setShowSearch', false);
};

const useDynamicColors = computed(() => !!route.meta.dynamicColors);
const { primaryColor } = useBackgroundColor();
</script>

<style scoped>
ion-tab-button {
  max-width: 150px;
  color: #929292;
}
:deep(.tab-selected) {
  color: #fff;
  ion-label {
    font-weight: bold;
  }
}
</style>
